import { render, staticRenderFns } from "./ui-configurations-view-tab.vue?vue&type=template&id=8426d140&scoped=true"
import script from "./ui-configurations-view-tab.vue?vue&type=script&lang=js"
export * from "./ui-configurations-view-tab.vue?vue&type=script&lang=js"
import style0 from "./ui-configurations-view-tab.vue?vue&type=style&index=0&id=8426d140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8426d140",
  null
  
)

export default component.exports